import axios from "axios";
const BACKEND_URI = "";

import { Caselet, QdrantObject, OptionRefactorPayload, SeedType, get_user_data, ParticipantsType, SourceWeightsType } from "../utils/common";
import { BaseURL, Chat, Seed, caselet, unPublishCaselet } from "../utils/appConstant";
import apiClient from "./axiosInstance";

export async function getFiles() {
    const userId = get_user_data().email;
    return apiClient.get(`/${Chat}`, { withCredentials: true });
}

export async function getFileChats(fileName: string | undefined) {
    const userId = get_user_data().email;
    return apiClient.get(`/${Chat}/${fileName}`, { withCredentials: true });
}

export async function generateChat(fileName: string | undefined, prompt: string) {
    const userId = get_user_data().email;
    return apiClient.post(`/${Chat}/${fileName}`, { query: prompt }, { withCredentials: true });
}

export async function save_content(fileName: string, privateContentObject: SeedType) {
    const userId = get_user_data().email;
    return apiClient.post(`/save-as-draft/${fileName}`, { privateContentObject }, { withCredentials: true });
}

export async function getSeedFiles() {
    return apiClient.get(`/${Seed}`, { withCredentials: true });
}

export async function getSeedList(page: number) {
    return apiClient.get(`/seedList`, { params: { page }, withCredentials: true });
}

export async function getSeedFileInfo(fileName: string | undefined) {
    return apiClient.get(`/${Seed}/${fileName}`, { withCredentials: true });
}

export async function searchSeedAPI(searchText: string) {
    return apiClient.post(`/searchSeed`, { searchText }, { withCredentials: true });
}

export async function fetchCaselet(user_id: string, conversation_id: string | undefined) {
    return apiClient.post(`/finetune/${unPublishCaselet}`, { conversation_id }, { withCredentials: true });
}

export async function saveUnpublishedCaselet(fileName: number, caseletObject: Caselet) {
    const userId = get_user_data().email;
    return apiClient.post(`/${unPublishCaselet}/${fileName}`, { caselet: caseletObject }, { withCredentials: true });
}

export async function savePublishedCaselet(fileName: string | number, caseletObject: Caselet) {
    return await axios.post(`${BaseURL}/${caselet}/${fileName}`, { caselet: caseletObject }, { withCredentials: true });
}

export async function generateNewDecisionPointUsingAI(userId: string, caseletId: string) {
    return await apiClient.put(`${BaseURL}/${unPublishCaselet}/newChallenge`, { caselet_id: caseletId }, { withCredentials: true });
}

export async function getPublishedCaseletsFiles() {
    return await apiClient.get(`${BaseURL}/${caselet}`, { withCredentials: true });
}

export async function getUnpublishedCaseletsFiles() {
    const userId = get_user_data().email;
    return await apiClient.get(`${BaseURL}/${unPublishCaselet}`, { withCredentials: true });
}

export async function getCaseletFileInfo(fileName: string | undefined) {
    return await apiClient.get(`${BaseURL}/${caselet}/${fileName}`, { withCredentials: true });
}

export async function getUnPublishedCaseletFileInfo(fileName: string | undefined) {
    const userId = get_user_data().email;
    return await apiClient.get(`${BaseURL}/${unPublishCaselet}/${fileName}`, { withCredentials: true });
}

export async function createNewOption(optionRefactorPayload: OptionRefactorPayload) {
    return await apiClient.put(`${BaseURL}/${unPublishCaselet}/challenge/newOption`, { caselet: optionRefactorPayload }, { withCredentials: true });
}

export async function regenerateChallengeOption(optionRefactorPayload: OptionRefactorPayload) {
    return await apiClient.put(`${BaseURL}/${unPublishCaselet}/challenge/regenerateOptions`, { caselet: optionRefactorPayload }, { withCredentials: true });
}

export async function getId() {
    return await apiClient.get(`${BaseURL}/generateId`, { withCredentials: true });
}

export async function checkFile(id: string | undefined) {
    const userId = get_user_data().email;
    return await apiClient.get(`${BaseURL}/checkfile/${id}`, { withCredentials: true });
}

export async function checkUser() {
    const userId = get_user_data().email;
    if (!userId) throw new Error("User ID is null.");
    return await apiClient.get(`${BaseURL}/check_user`, { withCredentials: true });
}

export async function searchCaseletAPI(searchText: string) {
    return await apiClient.post(`${BaseURL}/searchCaselet`, { searchText }, { withCredentials: true });
}

export async function saveCaseletInQdrant(caselet_data: any) {
    return await apiClient.post(`${BaseURL}/saveCaseletInQdrant`, { caselet_data }, { withCredentials: true });
}

export async function moveUnpublishedCaseletToPublishedDir(caselet_id: any) {
    const userId = get_user_data().email;
    return await apiClient.post(`${BaseURL}/moveCaselet/${userId}/${caselet_id}`, {}, { withCredentials: true });
}

export async function saveInQdrant(privateContentObject: any) {
    const userId = get_user_data().email;
    return await apiClient.post(`${BaseURL}/publish-exclusive-content`, { userId, privateContentObject }, { withCredentials: true });
}

export async function moveDraftToCentralSeedDir(QdrantTextObjectOfNewSeed: QdrantObject, fileName: string) {
    const userId = get_user_data().email;
    return await apiClient.post(`${BaseURL}/moveDraft`, { userId, QdrantTextObjectOfNewSeed, fileName }, { withCredentials: true });
}

export async function mentorMenteeEngagement(option: string) {
    return await apiClient.get(`${BaseURL}/engagement/summary?time_filter=${option}`, { withCredentials: true });
}

export async function menteeCaseletEngagement(option: string, mentor_name: string) {
    return await apiClient.get(`/engagement/caselet`, {
        params: { time_filter: option, mentor_name }
    });
}
export async function getDraftPrivateContentFiles() {
    const userId = get_user_data().email;
    return await apiClient.get(`/drafts`);
}
export async function getPrivateContentFileNames() {
    const userId = get_user_data().email;
    return await apiClient.get(`/get-files/${userId}`);
}

export async function getDraftPublishContentList() {
    const userId = get_user_data().email;
    return await apiClient.get(`/exclusive-content/list`);
}

// export async function getPrivateContentFileData(filename:string) {
//     const userId = get_user_data().email;
//     return await apiClient.get(`/get-exclusive-content/${userId}/${filename}`);
// }

export async function getPrivateContentDraftFileData(filename: string) {
    const userId = get_user_data().email;
    return await apiClient.get(`/exclusive-content/draft/${filename}`);
}
export async function getFinalizedContentFileInfo(fileName: string | undefined) {
    return apiClient.get(`/exclusive-content/published/${fileName}`);
}
export async function rollBackPrivateContent(fileName: string | undefined) {
    return await apiClient.post(`/rollback`, { fileName });
}

export async function deletePrivateContent(fileName: string, userId: string) {
    return await apiClient.delete(`/delete-draft`, {
        data: { fileName, userId }
    });
}

export async function getParticipants() {
    const userId = get_user_data().email;
    if (!userId) throw new Error("User ID is null");
    return await apiClient.get(`/participants`);
}

export async function addParticipants(participant_id: string, participantData: ParticipantsType) {
    const mentor_id = get_user_data().email;
    const mentor_name = get_user_data().name;
    if (!mentor_id || !mentor_name) throw new Error("Mentor ID or Mentor Name is null");
    return await apiClient.post(`/participant`, { participant_id, participantData, mentor_name, mentor_id });
}

export async function allInteractionsApi(startDate: string, endDate: string) {
    const mentor_id = get_user_data().email;
    return await apiClient.get(`/analytics/prompts`, {
        params: { start_date: startDate, end_date: endDate },
        headers: { "Access-Control-Expose-Headers": "Content-Disposition" },
        withCredentials: true
    });
}

export async function allLikeDislikedThreadsApi(startDate: string, endDate: string, checkedValue: string) {
    const mentor_id = get_user_data().email;
    return await apiClient.get(`/analytics/dislikedThreads`, {
        params: { start_date: startDate, end_date: endDate, checked_value: checkedValue },
        withCredentials: true
    });
}

export async function threadsResponseApi(threadId: string) {
    return await apiClient.get(`/analytics/thread`, {
        params: { threadId },
        withCredentials: true
    });
}

export async function allUnableToAnswerApi(startDate: string, endDate: string) {
    const mentor_id = get_user_data().email;
    return await apiClient.get(`/analytics/unanswered`, {
        params: { start_date: startDate, end_date: endDate },
        withCredentials: true
    });
}

export async function exportLikeDislikeInteractions(selectedRows: any) {
    return await apiClient.post(`/analytics/export-like-dislike-interactions`, { selectedRows }, { withCredentials: true });
}

export async function allInteractionsThreadsApi(startDate: string, endDate: string) {
    const mentor_id = get_user_data().email;
    return await apiClient.get(`/analytics/all-interactions`, {
        params: { start_date: startDate, end_date: endDate },
        withCredentials: true
    });
}

export async function getSourceWeights() {
    const user_email = get_user_data().email;
    return await apiClient.get(`/weights`, {
        // params: { user_id: user_email },
        withCredentials: true
    });
}

export async function saveSourceWeights(sourceWeights: SourceWeightsType) {
    return await apiClient.put(`/weights`, { sourceWeights }, { withCredentials: true });
}

export async function getPodcastCitationInfo(citation: string): Promise<any> {
    return await apiClient.get(`/podcast/summary`, {
        params: {
            citation: citation
        },
        withCredentials: true
    });
}

export async function getBookCitationInfo(book_name: string | undefined, chapter_name: string | undefined): Promise<any> {
    return await apiClient.get(`/book/pages`, {
        params: {
            book_name: book_name,
            chapter_name: chapter_name
        },
        withCredentials: true
    });
}

export async function getSourcesMetadata(media_type = "", status: string[] = []) {
    return await apiClient.get(`/sources`, {
        params: { media_type, status: status.join(",") },
        withCredentials: true
    });
}

export async function getSourcesByIds(ids: number[] | string[]) {
    return await apiClient.post(
        `/sources_by_ids`,
        {
            ids: ids
        },
        {
            withCredentials: true
        }
    );
}

export async function startSync() {
    // Run all requests in parallel and wait for all to finish
    // const requests = [
    //     apiClient.get(`/ingest-chows`, { withCredentials: true }),
    //     apiClient.get(`/ingest-blogs`, { withCredentials: true }),
    //     apiClient.get(`/process_sps_podcast`, { withCredentials: true }),
    //     apiClient.get(`/process_fsl_podcast`, { withCredentials: true })
    // ];
    // const res = Promise.all(requests);
    // return res;
    return await apiClient.get(`/ingest`, { withCredentials: true });
}

export async function getPodcastLinks() {
    return await apiClient.get(`/extract_podcast_links`, {
        withCredentials: true
    });
}

export async function getFslPodcastLinks() {
    return await apiClient.get(`/extract_fsl_podcast_links`, {
        withCredentials: true
    });
}

export async function updateRecordStatus(link: string, type: string, status: string) {
    // Replace with your actual API endpoint and payload
    return await axios.post(`${BaseURL}/update-source`, { link, type, status },{ withCredentials: true});
}

export async function getChowLinks() {
    return await apiClient.get(`/extract_chow_links`, {
        withCredentials: true
    });
}

export async function getBlogLinks() {
    return await apiClient.get(`/extract_blog_links`, {
        withCredentials: true
    });
}

export const checkIsAdmin = async () => {
    return await apiClient.get(`/is-super-admin`, {
        withCredentials: true
    });
};
